import { GroupBase } from 'react-select';
import ReactAsyncSelect, { AsyncProps } from 'react-select/async';
import { ISelectOption, ISelectCustomProps, IAsyncSelectCustomProps } from '../interfaces';
import SelectLayout from '../SelectLayout';
import useDebouncedLoadOptions from './useDebouncedLoadOptions';

const AsyncSelect = <
  SOption extends ISelectOption = ISelectOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<SOption> = GroupBase<SOption>,
>({
  useDebounce,
  ...selectProps
}: ISelectCustomProps<SOption, IsMulti, Group> & AsyncProps<SOption, IsMulti, Group> & IAsyncSelectCustomProps) => {
  const { loadOptions, noOptionsMessage } = useDebouncedLoadOptions<SOption, Group>({
    useDebounce,
    loadOptions: selectProps.loadOptions,
    defaultOptions: selectProps.defaultOptions,
    noOptionsMessage: selectProps.noOptionsMessage,
  });

  return (
    <SelectLayout
      { ...selectProps }
      loadOptions={ loadOptions }
      noOptionsMessage={ noOptionsMessage }
      component={ ReactAsyncSelect }
    />
  );
};

export default AsyncSelect;
